// extracted by mini-css-extract-plugin
export default {"loading-screen":"loading-screen_loading-screen__obW3l","content":"loading-screen_content__sAzox","text":"loading-screen_text__VZLH8"};